// @flow

import * as React from 'react'
import type { Actions } from '../../../types'
import Row from '../../../components/Row'
import ActionsColumn from '../../../components/ActionsHeaderColumn'
import Separator from '../../../components/Separator'
import ItemFullHistoryAction from '../../../components/actions/ItemFullHistoryAction'
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import AddItemHistoryToOrderAction from '../../../components/actions/AddItemHistoryToOrderAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery'

type Props = {
  minHeight: string,
}

const ActionsOrganizerAccounts = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    ResetAction,
    SaveViewAction,
    MultiSortAction,
    currentItem,
    getGlobalDisabledState,
    isOneRowSelected,
    loading,
    clearInternalFilters,
    selectedOrderDate,
    selectedOrderType,
    onItemAdded,
    itemAddedStatus,
    onItemUpdated,
    itemHistoryRefetch,
    inventoryRefetch,
    loadingInventory,
    inventoryRefetching,
    onAddItemComplete,
    activeOrderSource,
    orderRefetch,
    displayRowMenu,
    displayMenu,
  } = props

  const isFetching = loadingInventory || inventoryRefetching

  const refetchModules = () => {
    itemHistoryRefetch()
    inventoryRefetch()
    orderRefetch();
  }

  const addToOrder =             
  <AddItemHistoryToOrderAction
    onItemAdded={onItemAdded}
    itemAddedStatus={itemAddedStatus || ''}
    moduleName={'inventory'}
    selectedOrderType={selectedOrderType}
    selectedOrderDate={selectedOrderDate}
    disabled={isFetching || !currentItem}
    item={currentItem}
    onItemUpdated={onItemUpdated}
    activeOrder={activeOrderSource}
    onComplete={onAddItemComplete}
    moduleRefetch={refetchModules}
  />
  
  const fullItemHistory =             
    <ItemFullHistoryAction
      disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
      item={currentItem && {Code: currentItem.Code, Price: currentItem.Price.value, AcctNo: currentItem.AcctNo}}
    />

  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            <ExportAction />
          </ActionsColumn>

          <ActionsColumn>
            <CopyAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <SaveViewAction />
            <ResetAction />
          </ActionsColumn>

          <ActionsColumn>
            <ColumnsAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {fullItemHistory}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {addToOrder}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction
              clearInternalFilters={clearInternalFilters}
              disabled={loading}
            />
          </ActionsColumn>
          
          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        {displayRowMenu &&
          <div className='actions-menu-top-section'>
            <div style={{ fontWeight: 'bold', color: 'black' }}>{currentItem && currentItem.Description}</div>
          </div>
        }
        <div className='action-menu-items'>
          <ActionsColumn>
            <table>
              {displayMenu &&
                <tbody>
                  <tr>
                    <td><ExportAction /></td>
                  </tr>
                  <tr>
                    <td><SaveViewAction /></td>
                  </tr>
                  <tr>
                    <td><ResetAction /></td>
                  </tr>
                </tbody>
              }
              {displayRowMenu &&
                <tbody>
                  <tr>
                    <td><CopyAction /></td>
                    <td>{addToOrder}</td>
                  </tr>
                  <tr>
                    <td>{fullItemHistory}</td>
                  </tr>
                </tbody>
              }
            </table>
          </ActionsColumn>
        </div>
      </MobileView>
    </>
  )
}

export default ActionsOrganizerAccounts
